import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { RouterModule, Routes } from "@angular/router";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import "hammerjs";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { TranslateModule } from "@ngx-translate/core";
import { ToastrModule } from "ngx-toastr"; // For auth after login toast
import { CoreModule } from "@core/core.module";
import { CoreCommonModule } from "@core/common.module";
import { CoreSidebarModule } from "@core/components";

import { coreConfig } from "app/app-config";

import { AppComponent } from "app/app.component";
import { LayoutModule } from "app/layout/layout.module";
import { DashboardPagesModule } from "./pages/dashboardPages.module";
import { MainComponent } from "./pages/dashboard/main/main.component";
import { ErrorInterceptor, JwtInterceptor, OptionsInterceptor } from "./auth/helpers";
import { NgApexchartsModule } from "ng-apexcharts";
import { ErrorComponent } from "./pages/miscellaneous/error/error.component";
import { ContentHeaderModule } from "./layout/components/content-header/content-header.module";
import { NgxDatatableModule } from "@swimlane/ngx-datatable";
import { CoreCardModule } from "../@core/components/core-card/core-card.module";
import { CapabilityService } from "./auth/service/capability.service";
import { UserProfileDocumentsComponent } from "./pages/dashboard/user/profile-documents/user-profile-documents.component";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { MiscellaneousModule } from "./pages/miscellaneous/miscellaneous.module";
import { TaskModule } from "./modules/task/task.module";
import { JobPositionsModule } from "./modules/job-positions/job-positions.module";
import { EmployeeCostsModule } from "./modules/employee-costs/employee-costs.module";
import { RecruitmentModule } from "./modules/recruitment/recruitment.module";
import { TicketModule } from "./modules/ticket/ticket.module";
import { CollaboratorsModule } from "./modules/collaborators/collaborators.module";
import { AssetsModule } from "./modules/assets/assets.module";
import { ProvidersModule } from "./modules/providers/providers.module";
import { CostModule } from "./modules/cost/cost.module";
import { ChatModule } from "./modules/chat/chat.module";
import { ProductsModule } from "./modules/products/products.module";
import { WorkdayReportModule } from "./modules/workday-report/workday-report.module";
import { CustomerModule } from "./modules/customer/customer.module";
import { InvoiceModule } from "./modules/invoice/invoice.module";
// import attivi

const appRoutes: Routes = [
  {
    path: "",
    redirectTo: "auth/login",
    pathMatch: "full",
  },
  {
    path: "**",
    component: ErrorComponent,
  },
];

@NgModule({
  declarations: [AppComponent, MainComponent, UserProfileDocumentsComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    RouterModule.forRoot(appRoutes, {
      scrollPositionRestoration: "enabled", // Add options right here
      relativeLinkResolution: "legacy",
    }),
    TranslateModule.forRoot(),

    //NgBootstrap
    NgbModule,
    ToastrModule.forRoot(),
    MiscellaneousModule,
    // Core modules
    CoreModule.forRoot(coreConfig),
    CoreCommonModule,
    CoreSidebarModule,
    // App modules
    LayoutModule,
    // modulo per il routing custom
    DashboardPagesModule,
    NgApexchartsModule,
    ContentHeaderModule,
    NgxDatatableModule,
    CoreCardModule,
    DragDropModule,
    // moduli dell'app
    ChatModule,
    TaskModule,
    JobPositionsModule,
    InvoiceModule,
    CollaboratorsModule,
    EmployeeCostsModule,
    RecruitmentModule,
    TicketModule,
    AssetsModule,
    ProvidersModule,
    CostModule,
    ProductsModule,
    WorkdayReportModule,
    CustomerModule,
  ],

  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: OptionsInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    CapabilityService,
  ],

  bootstrap: [AppComponent],
})
export class AppModule {}
